import { Component, OnInit } from '@angular/core';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { ApiService } from '../../services/api.service';

@Component({
  	selector: 'app-change-password',
  	templateUrl: './change-password.component.html',
  	styleUrls: ['./change-password.component.css']
})

export class ChangePasswordComponent implements OnInit {

	private toasterService: ToasterService;
	password = '';
	confirm_password = '';
	
	error_password = '';
	error_confirm_password = '';

	eye1 = 'show';
	eyeSlash1 = 'hide';
	eye2 = 'show';
	eyeSlash2 = 'hide';

	constructor(private apiService: ApiService, toasterService: ToasterService) {
		this.toasterService = toasterService;
	}

	ngOnInit() { }

	showPassword(pass: any, number: number): any {
		pass.type = 'text';
		if(number == 1) {
			this.eye1 = 'hide';
			this.eyeSlash1 = 'show';	
		} else {
			this.eye2 = 'hide';
			this.eyeSlash2 = 'show';	
		}
	}

	hidePassword(pass: any, number: number): any {
		pass.type = 'password';
		if(number == 1) {
			this.eye1 = 'show';
			this.eyeSlash1 = 'hide';
		} else {
			this.eye2 = 'show';
			this.eyeSlash2 = 'hide';	
		}
	}

	changePassword() {
		if (this.password == "") {
			this.error_password = "required";
		} else if(this.password.length < 5) {
			this.error_password = "min. password length = 5";
		} else if (this.confirm_password == "") {
			this.error_confirm_password = "required";
		} else if(this.password != this.confirm_password) {
			this.error_confirm_password = "mismatch";
		} else {
			this.apiService.changePassword(this.password).subscribe( (data:any) => {
				// console.log('data=apiService.changePassword==>', JSON.stringify(data), '--data');
				this.toasterService.pop('success', data.message);
				let firstTimeLogin_token = sessionStorage.getItem('firstTimeLogin_token');
				if(firstTimeLogin_token) {
					sessionStorage.setItem('access_token_nv_admin', firstTimeLogin_token);
					sessionStorage.removeItem('firstTimeLogin_token');
					window.open("/home", "_self");
				} else {
					sessionStorage.clear();
					window.open("/login", "_self");
				}
			},
			error => {
				// console.log('error=apiService.changePassword==>', JSON.stringify(error), '--error');
				if(error.statusText ==  "Unauthorized") {
					sessionStorage.clear();
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else {
					sessionStorage.clear();
					 this.toasterService.pop('error', error.error.message);
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/change-password/change-password.component.ts